import React from 'react';
import { Card, CardMedia, Box, Typography, CardActions, IconButton, Button, CardHeader, CardContent } from '@mui/material';
import { Download, Visibility } from '@mui/icons-material';

const AwarenessMaterialCard = ({ id, iconUrl, title, description, pdfUrl, onTitleClick, style, layout = 'horizontal' }) => {
  
  if (layout === 'vertical') {
    return (
      <Card sx={{
        maxWidth: 345, 
        transition: 'background-color 0.3s ease',
        '&:hover': {
          bgcolor: 'grey.100' 
        },
        ...style 
        }}>
        <CardHeader
          sx={{
            height: 80,
            overflow: 'hidden',
            alignItems: 'flex-start'
          }}
          titleTypographyProps={{
            variant: 'h6',
            style: {
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
            },
          }}
          title={title}
        />
        {iconUrl && (
          <CardMedia
            component="img"
            height="160"
            image={iconUrl}
            alt={`${title} icon`}
            sx={{ objectFit: 'contain' }}
          />
        )}
        <CardContent sx={{ height: 90, overflow:"hidden" }}>
          <Typography variant="body2" color="text.secondary" sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'normal',
              display: '-webkit-box',
              WebkitLineClamp: 3,
              WebkitBoxOrient: 'vertical',
          }}>
            {description}
          </Typography>
        </CardContent>
        <CardActions disableSpacing sx={{ justifyContent: 'flex-end'}}>
          {onTitleClick && (
            <IconButton aria-label="learn more" onClick={onTitleClick} title="Learn More">
              <Visibility />
            </IconButton>
          )}
          {pdfUrl && (
            <IconButton 
              aria-label="download pdf" 
              href={pdfUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              title="Download PDF"
            >
              <Download />
            </IconButton>
          )}
        </CardActions>
      </Card>
    );
  }
  
  return (
    <Card 
      elevation={3} 
      sx={{
        display: 'flex',
        padding: '20px',
        borderRadius: '8px',
        width: '100%',
        mb: 2,
        transition: 'background-color 0.3s ease',
        '&:hover': { bgcolor: 'grey.100' },
        ...style 
      }}
    >
      {iconUrl && (
        <Box sx={{ width: '200px', height: '200px', marginRight: '20px', flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <CardMedia
            component="img"
            sx={{ width: 'auto', height: 'auto', maxHeight: '180px', maxWidth: '180px', objectFit: 'contain', borderRadius: '4px' }}
            image={iconUrl}
            alt={`${title} icon`}
          />
        </Box>
      )}
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <Box>
          <Typography 
            variant="h5"
            component="h2" 
            sx={{ 
              marginBottom: '10px', 
              cursor: onTitleClick ? 'pointer' : 'default',
              '&:hover': {
                textDecoration: onTitleClick ? 'underline' : 'none'
              }
            }}
            onClick={onTitleClick}
          >
            {title}
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ marginBottom: '15px' }}>
            {description && description.length > 180 ? `${description.slice(0, 180)}...` : description}
          </Typography>
        </Box>
        <CardActions sx={{ paddingLeft: 0, paddingRight: 0, justifyContent: 'flex-start', mt: 'auto' }}>
          {onTitleClick && (
            <IconButton aria-label="learn more" onClick={onTitleClick} sx={{ mr: 1 }}>
              <Visibility />
              <Typography variant="button" sx={{ ml: 0.5 }}>Learn More</Typography>
            </IconButton>
          )}
          {pdfUrl && (
            <IconButton 
              aria-label="download pdf" 
              href={pdfUrl} 
              target="_blank" 
              rel="noopener noreferrer"
              component_="a"
              sx={{ mr: 1 }}
            >
              <Download />
              <Typography variant="button" sx={{ ml: 0.5 }}>Download PDF</Typography>
            </IconButton>
          )}
        </CardActions>
      </Box>
    </Card>
  );
};

export default AwarenessMaterialCard; 